import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from './utils/utils.service';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  
  
  constructor(public utilsService: UtilsService) {
  }


  transform(value: any[], property: string): any[] {

    console.log(value);

    if (!Array.isArray(value) || !property) {
      return value;
    }

    return value.sort((a, b) => {
      if (this.utilsService._api(a[property], 'name') < this.utilsService._api(b[property], 'name')) {
        return -1;
      } else if (this.utilsService._api(a[property], 'name') > this.utilsService._api(b[property], 'name')) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}